export default "__VITE_ASSET__d69d1a00__"